import { connect } from 'react-redux';
import StripeComponent from '../views/subscription/StripComponent';
import { incrementCount } from '../../redux/actions/authentication';

const mapStateToProps = (state) => ({
    count : state.authentication.count
});

const mapDispatchToProps = (dispatch) => ({
    incrementCount : () => dispatch(incrementCount())
});

const Stripe = connect(
  mapStateToProps,
  mapDispatchToProps
)(StripeComponent);

export default Stripe;